<template>
  <div class="footer">
    <div class="footer-top">
      <!-- <div class="item">
        <img src="../assets/f-tel.png" alt="" /> XXXXXXXXXXXX
      </div> -->
      <div class="item">
        <img src="../assets/f-email.png" alt="" /> support@jobaid.com
      </div>
      <!-- <div class="item">
        <img src="../assets/f-address.png" alt="" /> 10 anson road #27-18 international plaza Singapore
      </div> -->
    </div>
    <!-- <div class="footer-box">
      <div class="logo-box">
        <img src="../assets/logo-1.png" class="logo-1" />
        <div class="br"></div>
        <div class="text">
          AZALEA will continue leveraging its industry advantages, strengthen
          cooperation with world-renowned companies, provide clients with higher
          quality services, and contribute to the development of the technology
          industry!
        </div>
      </div>
      <div class="menu-box">
        <div class="title">
          Quick Links
        </div>
        <div class="br"></div>
        <div class="list">
          <p @click="selectMenu(1)">> Home</p>
          <p @click="selectMenu(2)">> Company Profile</p>
          <p @click="selectMenu(3)">> Privacy Policy</p>
          <p @click="selectMenu(5)">> Contact Us</p>
        </div>
      </div>
      <div class="send-box">
        <div class="title">
          Newsletter
        </div>
        <div class="br"></div>
        <p>GET IN TOUCH</p>
        <input class="email" type="text" placeholder="Your Email" />
        <div class="btn" @click="send()">send</div>
      </div>
    </div> -->

    <!-- <div class="copyright">
            © WAVETECMOBI LIMITED
        </div> -->
  </div>
</template>
<style lang="less" scoped>
.footer {
  .footer-top {
    padding: 0 360px;
    height: 80px;
    line-height: 80px;
    background-color: #212121;
    display: flex;
    align-items: center;
    justify-content: center;
    .item {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      img {
        width: 48px;
        height: 48px;
        vertical-align: middle;
        margin-right: 24px;
      }
    }
  }
  .footer-box {
    height: 240px;
    background: #404040;
    padding: 120px 360px 106px 360px;
    display: flex;
    justify-content: space-between;
    .br {
      width: 60px;
      height: 2px;
      background-color: #504f4f;
      margin: 24px 0;
    }
    .logo-box {
      width: 400px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;

      .logo-1 {
        width: 220px;
        height: 40px;
      }
      .text {
      }
    }
    .menu-box {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 10px;
      .br {
        height: 1px;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      .list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 150px;
        p {
          cursor: pointer;
        }
      }
    }
    .send-box {
      margin-top: 10px;
      position: relative;
      .br {
        height: 1px;
      }
      p {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }
    .email {
      background: #151414;
      border-radius: 8px;
      border: 1px solid #999;
      padding: 0 20px;
      width: 190px;
      color: #cccccc;
      height: 56px;
      margin-top: 38px;
      padding-right: 100px;
    }
    input[type="text"]:focus {
      outline: none;
    }
    .btn {
      width: 78px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: #f53a68;
      border-radius: 8px;
      color:#fff ;
      position: absolute;
      right: 20px;
      top: 147px;
    }
    .customer {
      width: 120px;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .copyright {
    height: 64px;
    background: #2d2d2d;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 64px;
    text-align: center;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    send(){
      alert('send success')
    },
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "business" });
          break;
        case 3:
          this.$router.push({ path: "privacy" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "aboutUs" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
